// extracted by mini-css-extract-plugin
var _1 = "Modal-module__animateUploadProgressBarWidth--tVuLk";
var _2 = "Modal-module__animatedBackground--CSkRu";
var _3 = "Modal-module__body--WpqVk";
var _4 = "Modal-module__description--lhIc6";
var _5 = "Modal-module__expanded--x1xxy";
var _6 = "Modal-module__footerContainer--MQtbd";
var _7 = "Modal-module__modal--w_6PR";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "body", _4 as "description", _5 as "expanded", _6 as "footerContainer", _7 as "modal" }
